import * as React from "react";
const SvgFiRrWishlistStar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M17 0H7C4.243 0 2 2.243 2 5v15.996c0 1.235.742 2.329 1.889 2.786 1.149.46 2.439.173 3.317-.755l4.793-5.505 4.822 5.536a2.99 2.99 0 0 0 3.289.723 2.985 2.985 0 0 0 1.889-2.786V5c0-2.757-2.242-5-4.999-5m3 20.996c0 .629-.482.869-.629.929-.147.059-.663.215-1.069-.21l-5.548-6.371a.996.996 0 0 0-1.508 0l-5.52 6.34c-.433.456-.948.299-1.097.241-.147-.06-.629-.3-.629-.929V5c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3zM16.949 7.544a.83.83 0 0 1-.246.923l-1.971 1.606.815 2.484a.833.833 0 0 1-1.246.96l-2.295-1.495-2.257 1.51a.83.83 0 0 1-.964-.025.83.83 0 0 1-.295-.917l.784-2.513-1.981-1.612a.832.832 0 0 1 .539-1.468h2.501l.885-2.483a.833.833 0 0 1 1.562 0l.885 2.483h2.501c.35 0 .663.218.783.547"
    />
  </svg>
);
export default SvgFiRrWishlistStar;
